module.exports = __webpack_public_path__ + "img/cloud-1.52d29274.svg";